export default __webpack_public_path__ + "static/media/tick-icon.523bab1b.svg";